import { Component, OnInit } from '@angular/core';
import { DPO_CONSTANT } from 'src/app/utils/constant';
/*CAP-26096_POUDG-8493_Lot-2: Added new component */
@Component({
  selector: 'dpo-subscription-validated',
  templateUrl: './subscription-validated.component.html',
  styleUrls: ['./subscription-validated.component.scss']
})
export class SubscriptionValidatedComponent implements OnInit {
  langcode: string;
  isARLanguage: boolean;
  isOtherLanguage: boolean;
  constructor() { }
  ngOnInit() {
    this.langcode = localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);    
    if (this.langcode === 'ar-AE') {
      this.isARLanguage = true;
      this.isOtherLanguage = false;
    } else {
      this.isARLanguage = false;
      this.isOtherLanguage = true;
    }
  }

}
